import React from 'react';
import { UserCheck, Mail } from 'lucide-react';

interface HasJoinedStepProps {
  hasJoined: boolean | null;
  onSelect: (joined: boolean) => void;
  onCancel: () => void;
  onContinue: () => void;
}

const HasJoinedStep: React.FC<HasJoinedStepProps> = ({ hasJoined, onSelect, onCancel, onContinue }) => {
  return (
    <div className="space-y-8">
      <div className="text-center">
        <div className="w-16 h-16 bg-[#4339A0]/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <UserCheck className="w-8 h-8 text-[#4339A0]" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">Has the contact joined Clareefai yet?</h3>
        <p className="text-gray-500">Select whether this promoter already has an account</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-md mx-auto">
        <button
          onClick={() => onSelect(true)}
          className={`p-6 rounded-xl border-2 transition-all duration-200 text-center ${
            hasJoined === true
              ? 'border-[#4339A0] bg-[#4339A0]/5 ring-2 ring-[#4339A0]/20'
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <div className={`w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3 ${
            hasJoined === true ? 'bg-green-100' : 'bg-gray-100'
          }`}>
            <UserCheck className={`w-6 h-6 ${hasJoined === true ? 'text-green-600' : 'text-gray-400'}`} />
          </div>
          <p className="font-semibold text-gray-900">Yes</p>
          <p className="text-xs text-gray-500 mt-1">Already a member</p>
        </button>

        <button
          onClick={() => onSelect(false)}
          className={`p-6 rounded-xl border-2 transition-all duration-200 text-center ${
            hasJoined === false
              ? 'border-[#4339A0] bg-[#4339A0]/5 ring-2 ring-[#4339A0]/20'
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <div className={`w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3 ${
            hasJoined === false ? 'bg-blue-100' : 'bg-gray-100'
          }`}>
            <Mail className={`w-6 h-6 ${hasJoined === false ? 'text-blue-600' : 'text-gray-400'}`} />
          </div>
          <p className="font-semibold text-gray-900">No</p>
          <p className="text-xs text-gray-500 mt-1">Invite new promoter</p>
        </button>
      </div>

      <div className="flex justify-between pt-4">
        <button onClick={onCancel} className="px-6 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors">
          Cancel
        </button>
        <button
          onClick={onContinue}
          disabled={hasJoined === null}
          className="px-6 py-2.5 text-sm font-medium text-white bg-[#4339A0] hover:bg-[#3d2f8f] rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default HasJoinedStep;
